module.exports = __webpack_public_path__ + "media/images/icons/edit_black-4bf221730b4e668623fb28d25185e17d.svg";